export const bloodTestTranslations = {
    en: {
        // Page titles
        pageTitle: "Diagnostic tests ",
        bloodTestsFor: "Diagnostic tests for",
        allCampaigns: "All Campaigns",

        // Table headers
        srNo: "Sr. No.",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        remark: "Remark",
        testDate: "Test Date",
        testType: "Test Type",
        status: "Status",

        // Buttons
        addTest: "Add Test",
        addBloodTest: "Add Blood Test",
        viewBloodTestDetails: "View Blood Test Details",
        viewProfile: "View Profile",
        editTest: "Edit Test",
        deleteTest: "Delete Test",

        // Status
        campCompleted: "Camp Completed",
        testPending: "Test Pending",
        testCompleted: "Test Completed",
        resultAvailable: "Result Available",

        // Messages
        noTestsFound: "No tests found",
        loading: "Loading tests...",
        translating: "Translating...",

        // Search
        searchPlaceholder: "Search by name, token number...",

        // Test details
        hemoglobin: "Hemoglobin",
        bloodGroup: "Blood Group",
        sugarLevel: "Sugar Level",
        bloodPressure: "Blood Pressure",
        testResults: "Test Results",
        observations: "Observations",
        recommendations: "Recommendations",

        // Common
        unknown: "Unknown",
        notAvailable: "N/A",
        yes: "Yes",
        no: "No",
    },
    mr: {
        // Page titles
        pageTitle: "रक्त चाचण्या",
        bloodTestsFor: "रक्त चाचण्या",
        allCampaigns: "सर्व शिबिरे",

        // Table headers
        srNo: "अ.क्र.",
        tokenNo: "टोकन क्र",
        beneficiaryName: "लाभार्थी नाव",
        remark: "टिप्पणी",
        testDate: "चाचणी तारीख",
        testType: "चाचणी प्रकार",
        status: "स्थिती",

        // Buttons
        addTest: "चाचणी जोडा",
        addBloodTest: "रक्त चाचणी जोडा",
        viewBloodTestDetails: "रक्त चाचणी तपशील पहा",
        viewProfile: "प्रोफाइल पहा",
        editTest: "चाचणी संपादित करा",
        deleteTest: "चाचणी हटवा",

        // Status
        campCompleted: "शिबीर पूर्ण झाले",
        testPending: "चाचणी प्रलंबित",
        testCompleted: "चाचणी पूर्ण झाली",
        resultAvailable: "निकाल उपलब्ध",

        // Messages
        noTestsFound: "रक्त चाचण्या आढळल्या नाहीत",
        loading: "रक्त चाचण्या लोड करत आहे...",
        translating: "भाषांतर करत आहे...",

        // Search
        searchPlaceholder: "नाव, टोकन क्रमांकानुसार शोधा...",

        // Test details
        hemoglobin: "हिमोग्लोबिन",
        bloodGroup: "रक्त गट",
        sugarLevel: "साखर पातळी",
        bloodPressure: "रक्तदाब",
        testResults: "चाचणी निकाल",
        observations: "निरीक्षणे",
        recommendations: "शिफारसी",

        // Common
        unknown: "अज्ञात",
        notAvailable: "उपलब्ध नाही",
        yes: "होय",
        no: "नाही",
    }
};
